(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tapple-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.tappleStoreInitialized) return;
  window.tappleStoreInitialized = true;
  const configElement = document.querySelector('[data-tt-config]');
  if (!configElement) return;
  const text = JSON.parse(configElement.textContent);
  const root = window.Shopify?.routes?.root || '/';
  let cartQueue = Promise.resolve();
  let toastTimer;
  let returnFocus;
  const getDrawer = () => document.getElementById('tt-cart-drawer');
  const escapeKey = value => String(value).replace(/[^a-zA-Z0-9:_-]/g, '');
  function status(message) {
    document.querySelectorAll('[data-tt-cart-status]').forEach(el => { el.textContent = message; });
    const toast = document.getElementById('tt-status');
    if (toast) {
      toast.textContent = message;
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => { toast.hidden = true; }, 6500);
    }
  }
  function openDialog(dialog, trigger) {
    if (!dialog || dialog.open) return;
    returnFocus = trigger?.closest('dialog')?._ttOpener || trigger || document.activeElement;
    dialog._ttOpener = returnFocus;
    document.querySelectorAll('dialog[open]').forEach(el => el.close());
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    dialog.querySelector('[data-tt-close]')?.focus();
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    dialog.close();
    document.documentElement.style.overflow = '';
    if (returnFocus?.isConnected) returnFocus.focus();
  }
  document.addEventListener('close', event => {
    if (event.target instanceof HTMLDialogElement) {
      document.documentElement.style.overflow = '';
      if (returnFocus?.isConnected) returnFocus.focus();
    }
  }, true);
  async function jsonRequest(path, body) {
    const response = await fetch(root + path, {
      method: body === undefined ? 'GET' : 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      ...(body === undefined ? {} : { body: JSON.stringify(body) })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : text.error);
    return data;
  }
  async function refreshCart() {
    const source = new URL(root, window.location.origin);
    source.searchParams.set('section_id', 'tapple-cart');
    const response = await fetch(source, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(text.error);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const content = html.querySelector('[data-tt-cart-content]');
    if (!content) throw new Error(text.error);
    const active = document.activeElement;
    const key = active?.getAttribute('data-tt-key');
    const quantityInput = active?.hasAttribute('data-tt-quantity-input');
    document.querySelectorAll('[data-tt-cart-content]').forEach((target, index) => {
      const copy = content.cloneNode(true);
      if (index) {
        copy.querySelectorAll('[id]').forEach(el => { el.id += '-page'; });
        copy.querySelectorAll('[for]').forEach(el => { el.htmlFor += '-page'; });
      }
      target.replaceWith(copy);
    });
    document.querySelectorAll('[data-tt-cart-count]').forEach(el => { el.textContent = content.dataset.ttCartCountValue; });
    if (quantityInput && key) getDrawer()?.querySelector('[data-tt-quantity-input][data-tt-key="' + escapeKey(key) + '"]')?.focus();
  }
  function enqueue(work, control) {
    if (control) control.disabled = true;
    cartQueue = cartQueue.catch(() => {}).then(async () => {
      status(text.updating);
      document.querySelectorAll('[data-tt-cart-content]').forEach(el => { el.setAttribute('aria-busy', 'true'); });
      try { await work(); }
      catch (error) { status(error.message || text.error); }
      finally {
        if (control?.isConnected) control.disabled = false;
        document.querySelectorAll('[data-tt-cart-content]').forEach(el => { el.removeAttribute('aria-busy'); });
      }
    });
    return cartQueue;
  }
  function appliedCodes(cart) {
    const codes = (cart.cart_level_discount_applications || []).map(x => x.title);
    (cart.items || []).forEach(item => (item.line_level_discount_allocations || []).forEach(x => codes.push(x.discount_application?.title)));
    (cart.discount_codes || []).filter(x => x.applicable).forEach(x => codes.push(x.code));
    return codes.filter(Boolean).map(x => x.toUpperCase());
  }
  async function applyCode(code, copied = false) {
    const clean = code.trim();
    if (!clean) { status(text.enter_code); return; }
    const cart = await jsonRequest('cart/update.js', { discount: clean });
    await refreshCart();
    const applied = appliedCodes(cart).includes(clean.toUpperCase());
    let saved = false;
    try {
      if (!cart.item_count) { sessionStorage.setItem('tapplePendingDiscount', clean); saved = true; }
      else sessionStorage.removeItem('tapplePendingDiscount');
    } catch {}
    const message = !cart.item_count ? (saved ? text.apply_empty : text.empty_retry) : applied ? text.applied : text.invalid;
    status((copied ? text.copied + ' ' : '') + message);
  }
  async function updateQuantity(key, quantity) {
    if (!Number.isInteger(quantity) || quantity < 0) throw new Error(text.error);
    await jsonRequest('cart/change.js', { id: key, quantity });
    await refreshCart();
    status(text.updated);
  }
  function isCartAddForm(form) {
    const action = new URL(form.action, window.location.href);
    return action.origin === window.location.origin && /\/cart\/add(?:\.js)?$/.test(action.pathname);
  }
  // Add to cart from the button click so the browser never submits the form: Shopify reports
  // a submitted /cart/add form and the cart/add.js request as two separate add-to-cart events.
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('button[type="submit"], input[type="submit"]');
    const form = button?.form;
    if (!form || form.matches('[data-tt-discount-form]') || !isCartAddForm(form)) return;
    if (!form.checkValidity()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addFormToCart(form, button);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.matches('[data-tt-discount-form]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const code = new FormData(form).get('discount') || '';
      enqueue(() => applyCode(String(code)), form.querySelector('button[type="submit"]'));
      return;
    }
    if (!isCartAddForm(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addFormToCart(form, event.submitter || form.querySelector('button[type="submit"]'));
  }, true);
  function addFormToCart(form, button) {
    const formData = new FormData(form);
    enqueue(async () => {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: formData });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : text.error);
      await refreshCart();
      openDialog(getDrawer(), button);
      let pending = '';
      try { pending = sessionStorage.getItem('tapplePendingDiscount') || ''; } catch {}
      if (pending) await applyCode(pending);
      else status(text.added);
    }, button);
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const target = event.target;
    const productButton = target.closest('[data-tt-product-open]');
    if (productButton) { event.preventDefault();openDialog(document.getElementById(productButton.dataset.ttProductOpen), productButton);return; }
    const cartButton = target.closest('[data-tt-cart-open]');
    if (cartButton) { event.preventDefault();openDialog(getDrawer(), cartButton);enqueue(async () => { await refreshCart();status(''); });return; }
    const menuButton = target.closest('[data-tt-menu-open]');
    if (menuButton) { openDialog(document.getElementById('tt-mobile-menu'), menuButton);return; }
    const closeButton = target.closest('[data-tt-close]');
    if (closeButton) { closeDialog(closeButton.closest('dialog'));return; }
    if (target instanceof HTMLDialogElement) {
      const rect = target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(target);
    }
    const quantity = target.closest('[data-tt-quantity]');
    if (quantity) { enqueue(() => updateQuantity(quantity.dataset.ttKey, Number(quantity.dataset.ttQuantity)), quantity);return; }
    const coupon = target.closest('[data-tt-coupon]');
    if (coupon) {
      let copy = Promise.resolve(false);
      if (navigator.clipboard && window.isSecureContext) copy = navigator.clipboard.writeText('DIWALI15').then(() => true).catch(() => false);
      enqueue(async () => { const copied = await copy;openDialog(getDrawer(), coupon);await applyCode('DIWALI15', copied); }, coupon);return;
    }
    if (target.closest('[data-tt-remove-discount]')) { enqueue(async () => { try { sessionStorage.removeItem('tapplePendingDiscount'); } catch {} await jsonRequest('cart/update.js', { discount: '' });await refreshCart();status(text.updated); });return; }
    if (target.closest('[data-tt-replay]')) { playHero(true);return; }
    if (target.closest('[data-tt-pause]')) {
      const video = document.querySelector('.tt-hero-video');
      video?.pause();
      target.closest('[data-tt-pause]').hidden = true;
      document.querySelector('[data-tt-replay]')?.focus();
    }
    if (!target.closest('.tt-mega')) document.querySelectorAll('.tt-mega[open]').forEach(el => el.open = false);
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.matches('[data-tt-quantity-input]')) enqueue(() => updateQuantity(input.dataset.ttKey, Number(input.value)), input);
  });
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (details instanceof HTMLDetailsElement && details.matches('.tt-mega') && details.open) document.querySelectorAll('.tt-mega[open]').forEach(other => { if (other !== details) other.open = false; });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.tt-mega[open]').forEach(el => { el.open = false;el.querySelector('summary')?.focus(); });
  });
  document.addEventListener('focusin', event => {
    if (!(event.target instanceof Element) || event.target.closest('.tt-mega')) return;
    document.querySelectorAll('.tt-mega[open]').forEach(el => { el.open = false; });
  });
  function playHero(userInitiated = false) {
    const video = document.querySelector('.tt-hero-video');
    if (!video || (!userInitiated && (window.matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData))) return;
    if (video.dataset.played && !userInitiated) return;
    video.dataset.played = 'true';
    video.currentTime = 0;
    video.muted = true;
    video.playsInline = true;
    video.play().then(() => {
      video.classList.add('tt-playing');
      const pause = document.querySelector('[data-tt-pause]');if (pause) pause.hidden = false;
    }).catch(() => { video.classList.remove('tt-playing'); });
    video.onended = () => { video.classList.remove('tt-playing');const pause = document.querySelector('[data-tt-pause]');if (pause) pause.hidden = true; };
  }
  window.addEventListener('load', () => playHero(false), { once: true });
  if (document.readyState === 'complete') playHero(false);
  document.addEventListener('shopify:section:load', () => playHero(false));
  window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', event => { if (event.matches) { document.querySelector('.tt-hero-video')?.pause();document.querySelector('.tt-hero-video')?.classList.remove('tt-playing'); } });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tapple-reference-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.tappleReferenceInitialized) return;
  window.tappleReferenceInitialized = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const sliders = new Map();
  const films = new Map();
  function initialize(scope = document) {
    scope.querySelectorAll('[data-tr-slider]').forEach(el => {
      if (sliders.has(el)) return;
      const track = el.querySelector('[data-tr-track]');
      const slides = [...el.querySelectorAll('[data-tr-slide]')];
      const play = el.querySelector('[data-tr-autoplay]');
      let index = 0, timer, enabled = !reduced.matches, pointerX;
      function show(n) {
        if (!slides.length) return;
        index = (n + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;
        slides.forEach((slide, i) => { slide.inert = i !== index; slide.setAttribute('aria-hidden', String(i !== index)); });
        el.querySelector('[data-tr-slide-count]').textContent = `${index + 1} / ${slides.length}`;
      }
      function stop() { clearInterval(timer); }
      function start(force = false) {
        stop();
        play.textContent = enabled ? play.dataset.pause : play.dataset.play;
        if (enabled && slides.length > 1 && !document.hidden && (force || (!el.matches(':hover') && !el.contains(document.activeElement)))) timer = setInterval(() => show(index + 1), 6500);
      }
      function manual(delta) { enabled = false; stop(); show(index + delta); start(); }
      el.querySelector('[data-tr-prev]')?.addEventListener('click', () => manual(-1));
      el.querySelector('[data-tr-next]')?.addEventListener('click', () => manual(1));
      play?.addEventListener('click', () => { enabled = !enabled; start(true); });
      el.addEventListener('pointerenter', stop);
      el.addEventListener('pointerleave', start);
      el.addEventListener('focusin', stop);
      el.addEventListener('focusout', () => setTimeout(start, 0));
      track.addEventListener('pointerdown', e => { pointerX = e.clientX; });
      track.addEventListener('pointerup', e => { if (pointerX !== undefined && Math.abs(e.clientX - pointerX) > 50) manual(e.clientX < pointerX ? 1 : -1); pointerX = undefined; });
      track.addEventListener('pointercancel', () => { pointerX = undefined; });
      const observer = new IntersectionObserver(entries => { if (entries[0].isIntersecting) start(); else stop(); }, { threshold: .2 });
      observer.observe(el);
      sliders.set(el, { pause: () => { enabled = false; start(); }, start, stop, destroy: () => { stop(); observer.disconnect(); } });
      show(0);
      start();
    });
    scope.querySelectorAll('[data-tr-film]').forEach(el => {
      if (films.has(el)) return;
      const video = el.querySelector('video');
      const button = el.querySelector('[data-tr-video-toggle]');
      if (!video || !button) return;
      let userPaused = false;
      video.muted = true;
      video.playsInline = true;
      function refresh() { button.textContent = video.paused ? button.dataset.play : button.dataset.pause; }
      function play() { video.play().then(refresh).catch(refresh); }
      button.addEventListener('click', () => { if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); } });
      video.addEventListener('play', refresh);video.addEventListener('pause', refresh);
      const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && !reduced.matches && !navigator.connection?.saveData && !userPaused && !document.hidden) play();
        else video.pause();
      }, { threshold: .25 });
      observer.observe(el);
      films.set(el, { pause: () => video.pause(), destroy: () => { video.pause();observer.disconnect(); } });
    });
  }
  document.addEventListener('click', e => {
    if (!(e.target instanceof Element)) return;
    const close = e.target.closest('[data-tr-hotspot-close]');
    if (close) { const d = close.closest('details');d.open = false;d.querySelector('summary')?.focus(); }
    if (!e.target.closest('.tr-hotspot')) document.querySelectorAll('.tr-hotspot[open]').forEach(d => { d.open = false; });
  });
  document.addEventListener('toggle', e => {
    if (e.target instanceof HTMLDetailsElement && e.target.matches('.tr-hotspot') && e.target.open) document.querySelectorAll('.tr-hotspot[open]').forEach(d => { if (d !== e.target) d.open = false; });
  }, true);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') document.querySelectorAll('.tr-hotspot[open]').forEach(d => { d.open = false;d.querySelector('summary')?.focus(); }); });
  reduced.addEventListener('change', e => { if (e.matches) { sliders.forEach(x => x.pause());films.forEach(x => x.pause()); } });
  document.addEventListener('visibilitychange', () => { if (document.hidden) { sliders.forEach(x => x.stop());films.forEach(x => x.pause()); } else sliders.forEach(x => x.start()); });
  document.addEventListener('shopify:section:load', e => initialize(e.target));
  document.addEventListener('shopify:section:unload', e => { for (const [el,x] of sliders) if (e.target.contains(el)) { x.destroy();sliders.delete(el); } for (const [el,x] of films) if (e.target.contains(el)) { x.destroy();films.delete(el); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());else initialize();
})();


(() => {
  if (window.tappleCompactHeaderInitialized) return;
  window.tappleCompactHeaderInitialized = true;
  const body = document.body;
  let scheduled = false;
  function measureHeader() {
    const header = document.getElementById('header-group');
    if (!header) return;
    const compact = body.classList.contains('tr-header-compact');
    body.classList.remove('tr-header-compact');
    body.style.setProperty('--tr-expanded-header-height', Math.ceil(header.getBoundingClientRect().height) + 'px');
    body.classList.toggle('tr-header-compact', compact);
  }
  function updateHeader() {
    scheduled = false;
    const compact = body.classList.contains('tr-header-compact');
    if (!compact && window.scrollY > 160) body.classList.add('tr-header-compact');
    else if (compact && window.scrollY < 24) body.classList.remove('tr-header-compact');
  }
  function requestUpdate() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(updateHeader); }
  }
  function initializeHeader() { measureHeader(); updateHeader(); }
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', initializeHeader);
  window.addEventListener('pageshow', initializeHeader);
  document.addEventListener('shopify:section:load', initializeHeader);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeHeader);
  else initializeHeader();
  document.fonts?.ready.then(initializeHeader);
})();
  } catch(e) { console.error(e); }
})();

})();
